"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInviteCtrl = exports.InviteMethod = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const index_1 = require("../../i18n/index");
const page_1 = require("../../page/page");
const services_1 = require("../../services");
var InviteMethod;
(function (InviteMethod) {
    InviteMethod["LoggedIn"] = "current";
    InviteMethod["Login"] = "login";
    InviteMethod["Signup"] = "signup";
    InviteMethod["Undecided"] = "choose";
    InviteMethod["Success"] = "done";
    InviteMethod["SuccessSSO"] = "accountCreated";
    InviteMethod["FailedSSO"] = "accountError";
})(InviteMethod || (exports.InviteMethod = InviteMethod = {}));
class AcceptInviteCtrl {
    setValidEmail(isValid) {
        this.validEmail = isValid;
    }
    constructor(inviteToken) {
        this.awaitingCheck = false;
        this.loading = true;
        this.validatedToken = false;
        this.authFailed = false;
        this.inviteMethod = InviteMethod.Undecided;
        this.inviteToken = inviteToken;
    }
    handleError() {
        this.setLoading(false);
        notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
    }
    validateInviteToken() {
        this.setLoading(true);
        return services_1.Services.Department.Invite.verify(this.inviteToken)
            .then(valid => {
            this.setTokenValidity(valid);
            if (valid && services_1.Services.User.hasUser) {
                this.setInviteMethod(InviteMethod.LoggedIn);
            }
            this.setLoading(false);
        })
            .catch(() => this.handleError());
    }
    setInviteMethod(inviteMethod) {
        if (inviteMethod === InviteMethod.LoggedIn && !this.hasUser) {
            this.inviteMethod = InviteMethod.Undecided;
        }
        else {
            this.inviteMethod = inviteMethod;
        }
    }
    get user() {
        return services_1.Services.User.current;
    }
    get hasUser() {
        return services_1.Services.User.hasUser;
    }
    inviteLoggedInUser() {
        if (!this.hasUser) {
            throw new Error('No current user to invite');
        }
        this.setLoading(true);
        return services_1.Services.Department.Invite.accept(this.inviteToken)
            .then(() => services_1.Services.Department.updateDepartments())
            .then(() => {
            this.setLoading(false);
            return this.setInviteMethod(InviteMethod.Success);
        })
            .catch(e => {
            this.setLoading(false);
            if (core_shared_1.IkeRequestErrorChecker.isValidationFailed(e)) {
                notification_service_1.NotificationService.warn({ key: index_1.T.EMAIL_EXISTS_IN_DEPARTMENT });
            }
            else {
                notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
            }
        });
    }
    inviteByNewUser(user) {
        this.setLoading(true);
        return Promise.resolve()
            .then(() => services_1.Services.User.load(user))
            .then(() => this.inviteLoggedInUser())
            .catch(e => {
            this.setLoading(false);
            if (core_shared_1.IkeRequestErrorChecker.isValidationFailed(e)) {
                notification_service_1.NotificationService.warn({ key: index_1.T.EMAIL_INVALID });
            }
            else {
                notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
            }
        });
    }
    inviteNewSSOUser() {
        this.setLoading(true);
        return Promise.resolve()
            .then(() => services_1.Services.Department.Invite.acceptForce(this.inviteToken))
            .then(() => {
            this.setLoading(false);
            this.setInviteMethod(InviteMethod.SuccessSSO);
        })
            .catch(_ => {
            this.setLoading(false);
            notification_service_1.NotificationService.warn({ key: index_1.T.ERROR_GENERAL });
            this.setInviteMethod(InviteMethod.FailedSSO);
        });
    }
    failedNewSSOUser() {
        return Promise.resolve()
            .then(() => {
            this.setLoading(false);
            this.setInviteMethod(InviteMethod.FailedSSO);
        });
    }
    completeSSOInvite() {
        this.setLoading(true);
        return services_1.Services.Department.Invite.accept(this.inviteToken)
            .then(() => services_1.Services.Department.updateDepartments())
            .then(() => services_1.Services.Route.go(page_1.IkePageName.root))
            .catch(_ => {
            this.setLoading(false);
            notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
        });
    }
    completeInvite() {
        this.setLoading(true);
        return services_1.Services.Department.updateDepartments()
            .then(() => services_1.Services.Route.go(page_1.IkePageName.root))
            .catch(e => {
            this.setLoading(false);
            notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
        });
    }
    logout() {
        this.setLoading(true);
        services_1.Services.User.logout();
    }
    cancel() {
        services_1.Services.Route.go(page_1.IkePageName.root);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setTokenValidity(valid) {
        this.validatedToken = valid;
    }
    setAuthFailed(failed) {
        this.authFailed = failed;
    }
}
exports.AcceptInviteCtrl = AcceptInviteCtrl;
tslib_1.__decorate([
    mobx_1.observable
], AcceptInviteCtrl.prototype, "awaitingCheck", void 0);
tslib_1.__decorate([
    mobx_1.observable
], AcceptInviteCtrl.prototype, "loading", void 0);
tslib_1.__decorate([
    mobx_1.observable
], AcceptInviteCtrl.prototype, "validatedToken", void 0);
tslib_1.__decorate([
    mobx_1.observable
], AcceptInviteCtrl.prototype, "authFailed", void 0);
tslib_1.__decorate([
    mobx_1.observable
], AcceptInviteCtrl.prototype, "inviteMethod", void 0);
tslib_1.__decorate([
    mobx_1.action
], AcceptInviteCtrl.prototype, "setInviteMethod", null);
tslib_1.__decorate([
    mobx_1.action
], AcceptInviteCtrl.prototype, "setLoading", null);
tslib_1.__decorate([
    mobx_1.action
], AcceptInviteCtrl.prototype, "setTokenValidity", null);
tslib_1.__decorate([
    mobx_1.action
], AcceptInviteCtrl.prototype, "setAuthFailed", null);
//# sourceMappingURL=accept.invite.ctrl.js.map